/*
 * ACESO — ürün detay sayfası
 *
 * Varyant seçimi ve sepete ekleme, mobil galeri, tam ekran görsel büyütme, ölçü tablosu
 * ve ürün açıklamasının akordeon bölümlerine dağıtılması.
 */
(() => {
  const theme = window.theme;

  /* ------------------------------------------------------------------ */
  /* Ürün açıklamasını bölümlere ayırma                                   */
  /* ------------------------------------------------------------------ */

  /*
   * Mağazadaki ürün açıklamaları serbest metindir. Aşağıdaki ayrıştırıcı her satırı
   * yalnızca bir bölüme atar: genel tanım, özellikler, kumaş, kalıp, ölçüler, model
   * ölçüleri, bakım ve mağaza notları. Kaynak metin korunur; düzeltme yapılmaz.
   */
  const MATERIAL_PATTERN =
    /\b(?:KUMAS|PAMUK|KETEN|VISKON|TENSEL|TENCEL|MODAL|BAMBU|PENYE|SANDY|POLYESTER|POLYAMID|LIKRA|ELASTAN|TRIKO|KASE|VUAL|SIFON|SATEN|KADIFE|MANGO|DENIM|KOT|DERI|SILE BEZI|IKI IPLIK)\b/u;
  const FABRIC_QUALITY_PATTERN = /\b(?:NEFES AL|TERLETMEZ|YUMUSAK DOKU|AKISKAN|ESNEK KUMAS|DOKUMA KUMAS)\b/u;
  const FIT_PATTERN =
    /\b(?:KALIP|BEDEN|BEDENE KADAR|BEDENDEN|BEDEN ARALIGI|SALA[SZ]|OVERSIZE|BOL KESIM|RAHAT KESIM|A KESIM|VUCUD[AU] (?:SARMAZ|YAPISMAZ)|HAT BELLI ETMEZ)\b/u;
  const NOTICE_PATTERN = /\b(?:IADE[A-Z]*|DEGISIM[A-Z]*|KARGO[A-Z]*|ON[ -]SIPARIS[A-Z]*)\b/u;
  const CARE_PATTERN =
    /(?:\b\d{2}\s*DERECE(?:DE)?\b|\bYIKAMA(?: TALIMATI)?\b|\bYIKAN(?:ABILIR|MALI|MAMALI|MAZ)\b|\bKURUTMA\b|\bKURUTUL(?:ABILIR|MALI|MAMALI)\b|\bUTU(?:LEME|LENEBILIR|LENMELI)?\b|\bKURU TEMIZLEME\b|\bAGARTICI\b)/u;

  const foldTurkish = (value) =>
    value
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[ıİ]/g, 'i')
      .toUpperCase();

  const cleanLine = (value) =>
    value
      .replace(/\r/g, '')
      .replace(/ /g, ' ')
      .replace(/^[\s•·*]+/u, '')
      .replace(/^[-–—]\s+/u, '')
      .replace(/[\s•·]+$/u, '')
      .replace(/[ \t]+/g, ' ')
      .trim();

  const lineKey = (value) =>
    foldTurkish(value)
      .replace(/[^A-Z0-9%]+/g, ' ')
      .trim();

  const uniqueLines = (lines) => {
    const seen = new Set();
    return lines.filter((line) => {
      const key = lineKey(line);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const isRepeatedTitle = (line, productName) => {
    if (!productName) return false;
    const lineValue = lineKey(line);
    const nameValue = lineKey(productName);
    if (lineValue.length < 12 || nameValue.length < 12) return false;
    return lineValue === nameValue || nameValue.startsWith(`${lineValue} `) || lineValue.startsWith(`${nameValue} `);
  };

  const isFeatureHeading = (n) => /^URUN (?:OZELLIKLERI|DETAYLARI|BILGILERI)\s*[:;-]*$/u.test(n);
  const isMeasurementHeading = (n) => {
    if (n.length > 52 || !n.includes('OLCU')) return false;
    return (
      /^(?:(?:BEDEN(?: VE URUN)?|URUN|GIYSI)\s+)?OLCU(?:LER|LERI|SU|SULERI)?\s*[:;-]*$/u.test(n) ||
      /^BEDEN\s+OLCULERI\s*[:;-]*$/u.test(n)
    );
  };
  const isModelHeading = (n) => /^MODEL(?:IN)?\s+OLCULERI\s*[:;-]*$/u.test(n);
  const isCareHeading = (n) =>
    /^(?:KUMAS VE )?BAKIM(?: TALIMATLARI)?\s*[:;-]*$/u.test(n) || /^YIKAMA(?: VE BAKIM)?(?: TALIMATLARI)?\s*[:;-]*$/u.test(n);
  const isStructuralHeading = (n) => isFeatureHeading(n) || isMeasurementHeading(n) || isModelHeading(n) || isCareHeading(n);
  const isLabeledField = (n) => /^(?:KUMAS|MODEL|KALIP|STIL|KULLANIM|CEP|ON|YAKA|RENK(?: SECENEGI)?|BEDEN)\s*:/u.test(n);
  const isProductFeatureField = (n) => /^(?:MODEL|STIL|KULLANIM|CEP|ON|YAKA|RENK(?: SECENEGI)?)\s*:/u.test(n);
  const isCareLine = (n) => CARE_PATTERN.test(n);
  const isNoticeLine = (n) => NOTICE_PATTERN.test(n);
  const isFabricLine = (n) => MATERIAL_PATTERN.test(n) || FABRIC_QUALITY_PATTERN.test(n);
  const isFitLine = (n) => FIT_PATTERN.test(n);
  const isStrongMeasurementStart = (n) =>
    /^(?:XS|S|M|L|XL|XXL|XXXL)(?:\s*[-/]\s*(?:XS|S|M|L|XL|XXL|XXXL))?\s+BEDEN\b/u.test(n) ||
    /^\d+\s*BEDEN\b/u.test(n) ||
    /^BEDEN\s*\d+\s*(?:=|:|-)/u.test(n) ||
    /^STANDART\s+BEDEN(?:DIR)?\b/u.test(n) ||
    /\b\d+\s*BEDENE\s+KADAR\b/u.test(n) ||
    /^(?:GOGUS|BEL|BASEN|URUN BOYU|ELBISE BOYU|TUNIK BOYU|PANTOLON BOYU|BOY OLCUSU)\b.*(?:CM|OLCU)/u.test(n);

  const splitProse = (line) => {
    if (/^[^:]{1,28}:\s*\S/u.test(line)) return [line];
    const sentences = line
      .split(/(?<=[.!?…])\s+/u)
      .map(cleanLine)
      .filter(Boolean);
    return sentences.length ? sentences : [line];
  };

  const truncateAtWord = (value, maxLength) => {
    if (value.length <= maxLength) return value;
    const slice = value.slice(0, Math.max(1, maxLength - 1)).trimEnd();
    const lastSpace = slice.lastIndexOf(' ');
    const shortened = lastSpace >= Math.floor(maxLength * 0.6) ? slice.slice(0, lastSpace) : slice;
    return `${shortened.replace(/[,:;.!?…-]+$/u, '')}…`;
  };

  const createConciseSummary = (lines, productName, maxLength = 240, maxSentences = 2) => {
    const candidates = lines
      .filter((line) => !isRepeatedTitle(line, productName))
      .filter((line) => {
        const n = foldTurkish(line);
        return !isStructuralHeading(n) && !isLabeledField(n) && !isCareLine(n) && !isNoticeLine(n) && !isStrongMeasurementStart(n);
      })
      .flatMap(splitProse)
      .filter((line) => lineKey(line).length > 3);

    let summary = '';
    for (const sentence of candidates.slice(0, maxSentences)) {
      const next = summary ? `${summary} ${sentence}` : sentence;
      if (next.length <= maxLength) {
        summary = next;
        continue;
      }
      if (!summary) summary = truncateAtWord(sentence, maxLength);
      break;
    }
    return summary;
  };

  const parseProductContent = (rawLines, productName) => {
    const lines = uniqueLines(rawLines.map(cleanLine).filter(Boolean)).filter((line) => !isRepeatedTitle(line, productName));
    if (!lines.length) return null;

    const explicitMeasurementIndex = lines.findIndex((line) => isMeasurementHeading(foldTurkish(line)));
    const firstTerminalSection = lines.findIndex((line) => {
      const n = foldTurkish(line);
      return isModelHeading(n) || isCareHeading(n) || isCareLine(n);
    });
    const fallbackMeasurementIndex =
      explicitMeasurementIndex >= 0
        ? -1
        : lines.findIndex((line, index) => {
            if (firstTerminalSection >= 0 && index >= firstTerminalSection) return false;
            return isStrongMeasurementStart(foldTurkish(line));
          });
    const measurementIndex = explicitMeasurementIndex >= 0 ? explicitMeasurementIndex : fallbackMeasurementIndex;
    const summaryBoundaries = [
      measurementIndex,
      lines.findIndex((line) => isFeatureHeading(foldTurkish(line))),
      firstTerminalSection,
    ].filter((index) => index >= 0);
    const summarySource = lines.slice(0, summaryBoundaries.length ? Math.min(...summaryBoundaries) : lines.length);

    const content = { overview: [], features: [], fabric: [], fit: [], measurements: [], model: [], care: [], notices: [] };
    let state = 'overview';

    lines.forEach((line, index) => {
      const n = foldTurkish(line);
      if (isNoticeLine(n)) {
        content.notices.push(line);
        return;
      }
      if (isFeatureHeading(n)) {
        state = 'features';
        return;
      }
      if (isMeasurementHeading(n) || index === measurementIndex) {
        state = 'measurements';
        if (isMeasurementHeading(n)) return;
      }
      if (isModelHeading(n)) {
        state = 'model';
        return;
      }
      if (isCareHeading(n)) {
        state = 'care';
        return;
      }
      if (isCareLine(n)) {
        state = 'care';
        content.care.push(line);
        return;
      }
      if (state === 'measurements') {
        content.measurements.push(line);
        return;
      }
      if (state === 'model') {
        content.model.push(line);
        return;
      }
      if (state === 'care') {
        content.care.push(line);
        return;
      }
      splitProse(line).forEach((part) => {
        const np = foldTurkish(part);
        if (isNoticeLine(np)) content.notices.push(part);
        else if (isCareLine(np)) content.care.push(part);
        else if (isFabricLine(np)) content.fabric.push(part);
        else if (isFitLine(np)) content.fit.push(part);
        else if (isProductFeatureField(np)) content.features.push(part);
        else if (state === 'features') content.features.push(part);
        else content.overview.push(part);
      });
    });

    Object.keys(content).forEach((key) => {
      content[key] = uniqueLines(content[key]);
    });

    return {
      ...content,
      summary: createConciseSummary(summarySource, productName),
      productDetails: uniqueLines([...content.overview, ...content.features]),
      fabricAndCare: uniqueLines([...content.fabric, ...content.care]),
      sizeAndFit: uniqueLines([...content.fit, ...content.measurements]),
    };
  };

  /** Açıklama HTML'ini satırlara çevirir: her blok öğe ve <br> yeni satır başlatır. */
  const linesFromHtml = (container) => {
    const lines = [];
    let buffer = '';
    const flush = () => {
      if (buffer.trim()) lines.push(buffer);
      buffer = '';
    };
    const blockTags = new Set(['P', 'DIV', 'LI', 'UL', 'OL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'TR', 'TABLE', 'BLOCKQUOTE', 'SECTION']);
    const walk = (node) => {
      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          buffer += child.textContent.replace(/\n/g, ' ');
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          if (child.tagName === 'BR') {
            flush();
            return;
          }
          const isBlock = blockTags.has(child.tagName);
          if (isBlock) flush();
          walk(child);
          if (isBlock) flush();
        }
      });
    };
    walk(container);
    flush();
    return lines;
  };

  const fillList = (root, key, lines) => {
    const list = root.querySelector(`[data-content="${key}"]`);
    if (!list) return false;
    if (!lines.length) return false;
    list.replaceChildren(
      ...lines.map((line) => {
        const item = document.createElement('li');
        item.textContent = line;
        return item;
      }),
    );
    list.hidden = false;
    const wrapper = root.querySelector(`[data-content-wrapper="${key}"]`);
    if (wrapper) wrapper.hidden = false;
    const fallback = root.querySelector(`[data-content-fallback="${key}"]`);
    if (fallback) fallback.hidden = true;
    return true;
  };

  const distributeDescription = (root) => {
    const description = root.querySelector('[data-product-description][data-auto-split]');
    if (!description) return;
    const parsed = parseProductContent(linesFromHtml(description), description.dataset.productTitle);
    if (!parsed) return;

    const summary = root.querySelector('[data-content="summary"]');
    const fitText = root.querySelector('[data-content="fit"]');
    const hasDetails = fillList(root, 'productDetails', parsed.productDetails);
    fillList(root, 'fabricAndCare', parsed.fabricAndCare);
    /* Model ölçüleri varsa kendi ara başlığıyla beden listesinin sonuna eklenir. */
    const sizeList = root.querySelector('[data-content="sizeAndFit"]');
    const modelLabel = sizeList && sizeList.dataset.modelLabel;
    const sizeLines = parsed.model.length && modelLabel ? [...parsed.sizeAndFit, modelLabel, ...parsed.model] : parsed.sizeAndFit;
    fillList(root, 'sizeAndFit', sizeLines);
    fillList(root, 'notices', parsed.notices);

    if (summary && parsed.summary) {
      summary.textContent = parsed.summary;
      summary.hidden = false;
    }
    if (fitText && (parsed.fit[0] || fitText.dataset.fallback)) {
      fitText.textContent = parsed.fit[0] || fitText.dataset.fallback;
      root.querySelector('[data-content-wrapper="fit"]').hidden = false;
    }
    /* Ayrıştırma en az bir satır ürettiyse ham açıklama yerine düzenli liste gösterilir;
       ham metin ekran okuyucular ve arama motorları için DOM'da kalır. */
    if (hasDetails || parsed.summary) description.hidden = true;
  };

  /* ------------------------------------------------------------------ */
  /* Ürün bilgisi: varyant, fiyat, sepete ekleme                          */
  /* ------------------------------------------------------------------ */

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.picker = this.querySelector('variant-picker');
      this.form = this.querySelector('[data-product-form]');
      this.idInput = this.querySelector('[data-variant-id]');
      this.purchaseRow = this.querySelector('[data-purchase-row]');
      this.mobileAtc = this.querySelector('[data-mobile-atc]');
      this.available = this.dataset.productAvailable === 'true';

      this.addEventListener('variant:change', (event) => this.onVariantChange(event.detail));
      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      this.querySelector('[data-mobile-atc-button]')?.addEventListener('click', () => this.form?.requestSubmit());
      this.querySelector('[data-size-chart-link]')?.addEventListener('click', () => this.openSizeChart());

      if (this.mobileAtc) {
        this.onScroll = () => this.updateMobileAtc();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.updateMobileAtc();
      }

      distributeDescription(this);
      if (this.dataset.productHandle && !(window.Shopify && window.Shopify.designMode)) {
        /* "Son incelediklerin" bölümü yoksa da ürün geçmişe yazılır. */
        if (!document.querySelector('recently-viewed')) theme.recentlyViewed.push(this.dataset.productHandle);
      }
    }

    disconnectedCallback() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    }

    onVariantChange({ variant, selected, complete }) {
      this.picker?.showError(false);
      this.setFormError('');
      const stock = this.querySelector('[data-stock]');
      const note = this.querySelector('[data-mobile-atc-note]');
      const sizeLabel = selected.filter(Boolean).join(' / ');

      /* Değerin içinde zaten "beden" geçiyorsa ("BEDEN 1") sözcük yinelenmez. */
      const generic = theme.mentionsSize(sizeLabel);
      if (note) {
        const template = generic ? note.dataset.labelSelectedGeneric : note.dataset.labelSelected;
        note.textContent = complete ? template.replace('[size]', sizeLabel) : note.dataset.labelIdle;
      }
      if (!variant) {
        if (stock && this.available) stock.hidden = true;
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      this.querySelectorAll('[data-price-current]').forEach((element) => {
        element.textContent = variant.price_formatted;
      });
      this.querySelectorAll('[data-price-compare]').forEach((element) => {
        const onSale = variant.compare_at_price > variant.price;
        element.textContent = onSale ? variant.compare_at_price_formatted : '';
        element.hidden = !onSale;
      });
      this.querySelectorAll('[data-sku]').forEach((element) => {
        element.textContent = variant.sku || '';
      });
      const skuWrapper = this.querySelector('[data-sku-wrapper]');
      if (skuWrapper) skuWrapper.hidden = !variant.sku;

      if (stock && this.available) {
        stock.hidden = false;
        stock.classList.toggle('is-sold-out', !variant.available);
        const stockTemplate = variant.available
          ? (generic ? stock.dataset.templateInGeneric : stock.dataset.templateIn)
          : (generic ? stock.dataset.templateOutGeneric : stock.dataset.templateOut);
        stock.textContent = stockTemplate.replace('[size]', sizeLabel);
      }

      if (this.picker && this.picker.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      this.dispatchEvent(new CustomEvent('product:variant', { bubbles: true, detail: { variant } }));
    }

    setFormError(message) {
      const target = this.querySelector('[data-form-error]');
      if (!target) return;
      target.textContent = message;
      target.hidden = !message;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.picker && !this.picker.complete) {
        this.picker.showError(true);
        return;
      }
      const variant = this.picker ? this.picker.variant : null;
      const id = variant ? variant.id : this.idInput && this.idInput.value;
      if (!id || (variant && !variant.available)) return;

      const button = this.querySelector('[data-add-to-cart]');
      const quantityInput = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
      const quantity = quantityInput ? Math.max(1, Number(quantityInput.value) || 1) : 1;
      const item = { id: Number(id), quantity };
      const sellingPlan = this.form.querySelector('[name="selling_plan"]');
      if (sellingPlan && sellingPlan.value) item.selling_plan = sellingPlan.value;
      const properties = {};
      new FormData(this.form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;

      button?.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      try {
        await theme.cart.add([item]);
        this.setFormError('');
        theme.cart.reveal(button);
      } catch (error) {
        this.setFormError(error.message);
      } finally {
        button?.removeAttribute('aria-busy');
        if (button) button.disabled = !this.available;
      }
    }

    openSizeChart() {
      const item = document.getElementById('pdp-size-chart');
      if (!item) return;
      item.open = true;
      window.requestAnimationFrame(() =>
        item.scrollIntoView({ behavior: theme.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' }),
      );
    }

    /* Sepete ekle satırı ekrandan çıkınca ve öneriler henüz görünmüyorken çubuğu gösterir. */
    updateMobileAtc() {
      if (!this.purchaseRow) return;
      const purchaseRect = this.purchaseRow.getBoundingClientRect();
      const recommendations = document.querySelector('.recommendations');
      const beforeRecommendations = recommendations
        ? recommendations.getBoundingClientRect().top > window.innerHeight * 0.72
        : true;
      const visible = purchaseRect.bottom < 0 && beforeRecommendations;
      this.mobileAtc.classList.toggle('is-visible', visible);
      this.mobileAtc.setAttribute('aria-hidden', String(!visible));
      const button = this.mobileAtc.querySelector('button');
      if (button) button.tabIndex = visible ? 0 : -1;
    }
  }
  customElements.define('product-info', ProductInfo);

  /* ------------------------------------------------------------------ */
  /* Galeri                                                               */
  /* ------------------------------------------------------------------ */
  /* Ürün videosu                                                         */
  /* ------------------------------------------------------------------ */

  /**
   * Galerideki video görünür olduğunda sessiz ve döngülü oynar, ekrandan çıkınca
   * durur. Tarayıcının denetim çubuğu yerine iki düğme vardır: duraklat/oynat ve ses.
   * Hareket azaltma tercihinde video duraklatılmış başlar.
   */
  class ProductVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.ready) return;
      this.ready = true;
      this.video.controls = false;
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.classList.add('is-enhanced');

      this.toggleButton = this.querySelector('[data-video-toggle]');
      this.muteButton = this.querySelector('[data-video-mute]');
      this.userPaused = theme.prefersReducedMotion();
      this.visible = false;

      this.toggleButton?.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        this.sync();
      });
      this.muteButton?.addEventListener('click', () => {
        this.video.muted = !this.video.muted;
        this.render();
      });
      ['play', 'pause', 'volumechange'].forEach((type) => this.video.addEventListener(type, () => this.render()));

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
            this.sync();
          },
          { threshold: [0, 0.5] },
        );
        this.observer.observe(this);
      } else {
        this.visible = true;
        this.sync();
      }
      this.render();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.video?.pause();
    }

    sync() {
      if (this.visible && !this.userPaused) {
        const playing = this.video.play();
        if (playing && playing.catch) playing.catch(() => {});
      } else {
        this.video.pause();
      }
      this.render();
    }

    render() {
      const paused = this.video.paused;
      const swap = (button, state, labelOn, labelOff, iconOn, iconOff) => {
        if (!button) return;
        button.setAttribute('aria-label', state ? button.dataset[labelOn] : button.dataset[labelOff]);
        const on = button.querySelector(iconOn);
        const off = button.querySelector(iconOff);
        if (on) on.hidden = !state;
        if (off) off.hidden = state;
      };
      swap(this.toggleButton, paused, 'labelPlay', 'labelPause', '[data-icon-play]', '[data-icon-pause]');
      swap(this.muteButton, this.video.muted, 'labelUnmute', 'labelMute', '[data-icon-muted]', '[data-icon-sound]');
    }
  }
  customElements.define('product-video', ProductVideo);

  /* ------------------------------------------------------------------ */

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-gallery-rail]');
      this.counter = this.querySelector('[data-gallery-counter]');
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dots] > i'));

      if (this.rail) {
        this.rail.addEventListener(
          'scroll',
          () => {
            const index = Math.round(this.rail.scrollLeft / Math.max(this.rail.clientWidth, 1));
            this.setActive(index);
          },
          { passive: true },
        );
      }

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-lightbox-index]');
        if (!trigger) return;
        const lightbox = document.getElementById(this.dataset.lightbox);
        if (lightbox && typeof lightbox.openAt === 'function') lightbox.openAt(Number(trigger.dataset.lightboxIndex), trigger);
      });

      /* Varyantın kendi görseli varsa galeriyi o görsele getirir. */
      this.onVariant = (event) => {
        const mediaId = event.detail.variant && event.detail.variant.featured_media_id;
        if (!mediaId) return;
        const target = this.querySelector(`.pdp-gallery-grid [data-media-id="${mediaId}"]`);
        const railTarget = this.rail && this.rail.querySelector(`[data-media-id="${mediaId}"]`);
        if (railTarget && this.rail.offsetParent) this.rail.scrollTo({ left: railTarget.offsetLeft });
        else if (target && target.offsetParent) target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      };
      document.addEventListener('product:variant', this.onVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant', this.onVariant);
    }

    setActive(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      if (this.counter) this.counter.textContent = `${index + 1} / ${this.dots.length || 1}`;
      this.dots.forEach((dot, position) => dot.classList.toggle('is-active', position === index));
    }

    /** Büyütme kapanınca mobil rayı son bakılan görsele getirir. */
    showImage(lightboxIndex) {
      if (!this.rail || !this.rail.offsetParent) return;
      const target = this.rail.querySelector(`[data-lightbox-index="${lightboxIndex}"]`);
      if (target) this.rail.scrollTo({ left: target.offsetLeft });
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ------------------------------------------------------------------ */
  /* Tam ekran görsel büyütme                                             */
  /* ------------------------------------------------------------------ */

  /*
   * Görselin tamamı sığdırılarak açılır; tıklama/çift dokunma, tekerlek, +/− ve iki
   * parmakla yakınlaştırılır, yakınken sürüklenerek gezilir. Yakın değilken kaydırma,
   * oklar, klavye ve küçük görsellerle görseller arasında geçilir.
   */
  const MAX_ZOOM = 4;
  const CLICK_ZOOM = 2.5;

  class ProductLightbox extends theme.OverlayDialog {
    connectedCallback() {
      super.connectedCallback();
      if (!this.initialised || this.lightboxReady) return;
      this.lightboxReady = true;

      this.stage = this.querySelector('[data-lightbox-stage]');
      this.image = this.querySelector('[data-lightbox-image]');
      this.thumbsWrapper = this.querySelector('[data-lightbox-thumbs]');
      this.thumbs = Array.from(this.querySelectorAll('[data-lightbox-thumbs] > button'));
      this.counter = this.querySelector('[data-lightbox-counter]');
      this.tip = this.querySelector('[data-lightbox-tip]');
      this.zoomLevel = this.querySelector('[data-zoom-level]');
      this.zoomIn = this.querySelector('[data-zoom-in]');
      this.zoomOut = this.querySelector('[data-zoom-out]');
      this.arrows = Array.from(this.querySelectorAll('.product-lightbox__arrow'));
      this.sources = this.thumbs.length
        ? this.thumbs.map((thumb) => thumb.dataset.full)
        : Array.from(this.querySelectorAll('[data-lightbox-single]')).map((item) => item.dataset.full);
      this.index = 0;
      this.zoom = { scale: 1, x: 0, y: 0 };
      this.pointers = new Map();
      this.gesture = { startX: 0, startY: 0, originX: 0, originY: 0, moved: false, onImage: false };

      this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.show(index)));
      this.querySelector('[data-lightbox-previous]')?.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-lightbox-next]')?.addEventListener('click', () => this.go(1));
      this.zoomIn?.addEventListener('click', () => this.zoomAt(this.zoom.scale + 0.75));
      this.zoomOut?.addEventListener('click', () => this.zoomAt(this.zoom.scale - 0.75));

      this.stage.addEventListener('pointerdown', (event) => this.onPointerDown(event));
      this.stage.addEventListener('pointermove', (event) => this.onPointerMove(event));
      this.stage.addEventListener('pointerup', (event) => this.onPointerUp(event));
      this.stage.addEventListener('pointercancel', (event) => this.onPointerUp(event));
      this.stage.addEventListener(
        'wheel',
        (event) => {
          event.preventDefault();
          this.zoomAt(this.zoom.scale * (event.deltaY < 0 ? 1.18 : 1 / 1.18), event.clientX, event.clientY);
        },
        { passive: false },
      );

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(-1);
        } else if (event.key === '+' || event.key === '=') {
          this.zoomAt(this.zoom.scale + 0.75);
        } else if (event.key === '-') {
          this.zoomAt(this.zoom.scale - 0.75);
        }
      });

      this.addEventListener('overlay:close', () => {
        const gallery = document.querySelector('product-gallery');
        if (gallery) gallery.showImage(this.index);
      });
    }

    openAt(index, opener) {
      this.show(index);
      this.open(opener);
    }

    get count() {
      return this.sources.length;
    }

    go(direction) {
      if (this.count < 2) return;
      this.show((this.index + direction + this.count) % this.count);
    }

    show(index) {
      this.index = index;
      this.setZoom({ scale: 1, x: 0, y: 0 });
      /* Görsel değişirken giriş animasyonu yeniden oynasın diye düğüm yenilenir.
         Büyük dosya inene kadar galeride zaten yüklenmiş olan görsel gösterilir. */
      const fresh = this.image.cloneNode(false);
      const full = this.sources[index];
      const preview = this.previewFor(index);
      fresh.src = preview || full;
      if (preview && preview !== full) {
        const loader = new Image();
        loader.onload = () => {
          if (this.image === fresh) fresh.src = full;
        };
        loader.src = full;
      }
      fresh.alt = (this.image.dataset.altTemplate || '').replace('[index]', String(index + 1));
      fresh.style.transform = '';
      this.image.replaceWith(fresh);
      this.image = fresh;
      if (this.counter) this.counter.textContent = `${index + 1} / ${this.count}`;
      this.thumbs.forEach((thumb, position) => {
        const active = position === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', String(active));
        if (active && this.isOpen) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
    }

    /** Galeride görünen (yüklenmiş) görselin adresi. */
    previewFor(index) {
      const candidates = document.querySelectorAll(`product-gallery [data-lightbox-index="${index}"] img`);
      for (const image of candidates) {
        if (image.offsetParent !== null && image.complete && image.currentSrc) return image.currentSrc;
      }
      return null;
    }

    /* Yakınlaştırmada görselin kenarı sahnenin içine kaçmasın. */
    clamp(next) {
      const scale = Math.min(MAX_ZOOM, Math.max(1, next.scale));
      const stage = this.stage;
      const image = this.image;
      const fit = Math.min(stage.clientWidth / (image.naturalWidth || 1), stage.clientHeight / (image.naturalHeight || 1));
      const shownWidth = image.naturalWidth ? image.naturalWidth * fit : stage.clientWidth;
      const shownHeight = image.naturalHeight ? image.naturalHeight * fit : stage.clientHeight;
      const maxX = Math.max(0, (shownWidth * scale - stage.clientWidth) / 2);
      const maxY = Math.max(0, (shownHeight * scale - stage.clientHeight) / 2);
      return { scale, x: Math.min(maxX, Math.max(-maxX, next.x)), y: Math.min(maxY, Math.max(-maxY, next.y)) };
    }

    setZoom(next) {
      this.zoom = next;
      const zoomed = next.scale > 1.01;
      if (this.image) this.image.style.transform = `translate3d(${next.x}px, ${next.y}px, 0) scale(${next.scale})`;
      this.stage.classList.toggle('is-zoomed', zoomed);
      if (this.zoomLevel) this.zoomLevel.textContent = `${Math.round(next.scale * 100)}%`;
      if (this.zoomOut) this.zoomOut.disabled = !zoomed;
      if (this.zoomIn) this.zoomIn.disabled = next.scale >= MAX_ZOOM;
      this.arrows.forEach((arrow) => {
        arrow.hidden = zoomed;
      });
      if (this.tip) this.tip.textContent = zoomed ? this.tip.dataset.tipPan : this.tip.dataset.tipZoom;
    }

    /* (clientX, clientY) noktası yerinde kalacak şekilde ölçeği değiştirir. */
    zoomAt(targetScale, clientX, clientY) {
      const rect = this.stage.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const pointX = (clientX == null ? centerX : clientX) - centerX;
      const pointY = (clientY == null ? centerY : clientY) - centerY;
      const scale = Math.min(MAX_ZOOM, Math.max(1, targetScale));
      const ratio = scale / this.zoom.scale;
      this.setZoom(
        this.clamp({ scale, x: pointX - (pointX - this.zoom.x) * ratio, y: pointY - (pointY - this.zoom.y) * ratio }),
      );
    }

    onPointerDown(event) {
      if (event.target.closest('button')) return;
      this.stage.setPointerCapture(event.pointerId);
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const state = this.gesture;
      if (this.pointers.size === 2) {
        const [a, b] = [...this.pointers.values()];
        state.pinchDistance = Math.hypot(a.x - b.x, a.y - b.y);
        state.pinchScale = this.zoom.scale;
        state.moved = true;
        return;
      }
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.originX = this.zoom.x;
      state.originY = this.zoom.y;
      state.moved = false;
      state.onImage = event.target === this.image;
      this.stage.classList.add('is-dragging');
    }

    onPointerMove(event) {
      if (!this.pointers.has(event.pointerId)) return;
      this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const state = this.gesture;
      if (this.pointers.size === 2 && state.pinchDistance && state.pinchScale) {
        const [a, b] = [...this.pointers.values()];
        this.zoomAt(state.pinchScale * (Math.hypot(a.x - b.x, a.y - b.y) / state.pinchDistance), (a.x + b.x) / 2, (a.y + b.y) / 2);
        return;
      }
      const dx = event.clientX - state.startX;
      const dy = event.clientY - state.startY;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) state.moved = true;
      if (this.zoom.scale > 1) this.setZoom(this.clamp({ scale: this.zoom.scale, x: state.originX + dx, y: state.originY + dy }));
    }

    onPointerUp(event) {
      if (!this.pointers.has(event.pointerId)) return;
      this.pointers.delete(event.pointerId);
      const state = this.gesture;
      if (this.pointers.size > 0) return;
      this.stage.classList.remove('is-dragging');
      state.pinchDistance = undefined;
      const dx = event.clientX - state.startX;
      const dy = event.clientY - state.startY;
      if (this.zoom.scale <= 1.01 && state.moved && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        this.go(dx < 0 ? 1 : -1);
        return;
      }
      if (state.moved) return;
      /* Dokunma/tıklama: yakın değilse o noktaya yakınlaştır, yakınsa sığdır. */
      if (this.zoom.scale > 1.01) this.setZoom({ scale: 1, x: 0, y: 0 });
      else if (state.onImage) this.zoomAt(CLICK_ZOOM, event.clientX, event.clientY);
    }
  }
  customElements.define('product-lightbox', ProductLightbox);

  /* ------------------------------------------------------------------ */
  /* Ölçü tablosu                                                         */
  /* ------------------------------------------------------------------ */

  class SizeChart extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.scroller = this.querySelector('.size-chart__scroller');
      this.hint = this.querySelector('.size-chart__hint');
      if (!this.scroller) return;
      if (this.hasAttribute('data-normalize')) this.normalize();

      this.measure = this.measure.bind(this);
      this.scroller.addEventListener('scroll', this.measure, { passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.scroller);
      }
      /* Tablo kapalı bir akordeonun içindeyse ilk ölçüm açılınca yapılır. */
      this.closest('details')?.addEventListener('toggle', this.measure);
      this.measure();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    /* Ürün açıklamasından gelen ham tabloyu tasarımdaki yapıya çevirir: ilk satır başlık,
       ilk sütun satır başlığı; satır içi stiller ve boş satırlar atılır. */
    normalize() {
      const table = this.querySelector('table');
      if (!table) return;
      const rows = Array.from(table.querySelectorAll('tr'))
        .map((row) => Array.from(row.children).map((cell) => cell.textContent.replace(/\s+/g, ' ').trim()))
        .filter((cells) => cells.some(Boolean));
      if (rows.length < 2) return;
      const caption = table.querySelector('caption');
      const [header, ...body] = rows;
      const head = document.createElement('thead');
      const headRow = document.createElement('tr');
      header.forEach((cell) => {
        const th = document.createElement('th');
        th.scope = 'col';
        th.textContent = cell;
        headRow.append(th);
      });
      head.append(headRow);
      const tbody = document.createElement('tbody');
      body.forEach((cells) => {
        const row = document.createElement('tr');
        const filled = cells.filter(Boolean);
        /* Tek hücreli satır ("Tunik", "Etek") alt bölüm başlığıdır; tabloyu boydan boya kaplar. */
        if (filled.length === 1 && cells[0]) {
          const group = document.createElement('th');
          group.scope = 'colgroup';
          group.colSpan = header.length;
          group.textContent = cells[0];
          row.className = 'size-chart__group';
          row.append(group);
          tbody.append(row);
          return;
        }
        cells.forEach((cell, index) => {
          const element = document.createElement(index === 0 ? 'th' : 'td');
          if (index === 0) element.scope = 'row';
          element.textContent = cell || '—';
          row.append(element);
        });
        tbody.append(row);
      });
      table.replaceChildren(...(caption ? [caption] : []), head, tbody);
      this.classList.toggle('is-wide', header.length >= 7);
    }

    measure() {
      const hasMore = this.scroller.scrollWidth > this.scroller.clientWidth + 2;
      const atEnd = !hasMore || this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 4;
      this.classList.toggle('has-overflow', hasMore);
      this.classList.toggle('is-at-end', atEnd);
      if (this.hint) {
        this.hint.hidden = !hasMore;
        this.hint.setAttribute('aria-hidden', String(atEnd));
      }
      if (hasMore) {
        this.scroller.tabIndex = 0;
        this.scroller.setAttribute('aria-label', this.scroller.dataset.label);
      } else {
        this.scroller.removeAttribute('tabindex');
        this.scroller.removeAttribute('aria-label');
      }
    }
  }
  customElements.define('size-chart', SizeChart);
})();
